// EARNOS web design tokens — mirrors mobile src/theme.ts
export const colors = {
  surface: "#0A0A0C",
  onSurface: "#F4F4F5",
  surfaceSecondary: "#121217",
  onSurfaceSecondary: "#A1A1AA",
  surfaceTertiary: "#1C1C24",
  onSurfaceTertiary: "#D4D4D8",
  brand: "#4F46E5",
  brandSecondary: "#6366F1",
  brandTertiary: "#7C3AED",
  onBrand: "#FFFFFF",
  success: "#10B981",
  warning: "#F59E0B",
  error: "#EF4444",
  info: "#3B82F6",
  border: "#27272A",
  borderStrong: "#3F3F46",
};

export const statusColor = {
  New: "#6366F1",
  Researching: "#3B82F6",
  "Draft ready": "#8B5CF6",
  "Awaiting approval": "#F59E0B",
  Contacted: "#0EA5E9",
  Replied: "#14B8A6",
  Meeting: "#A855F7",
  "Proposal sent": "#F59E0B",
  Won: "#10B981",
  Lost: "#EF4444",
  Paused: "#71717A",
};

export function money(n, opts) {
  const v = Number(n || 0);
  return `$${v.toLocaleString(undefined, opts)}`;
}
